interface TicketStateProps {
  className?: string;
  children: React.ReactNode;
}

const TicketState: React.FC<TicketStateProps> = ({ className, children }) => {
  return (
    <div className={`date-space  ${className}`}>
      <div className="date-block ">{children}</div>
    </div>
  );
};

export default TicketState;
